import { CARGO_TYPE_ID } from '@types';

export const getCargoTypeFromCargoTypeId = (cargoTypeId?: number): string | '' => {
	switch (cargoTypeId) {
	case CARGO_TYPE_ID.FullTruckload:
		return 'FTL';
	case CARGO_TYPE_ID.Pallets:
		return 'PALLETS';
	case CARGO_TYPE_ID.Volumetric:
		return 'VOLUME';
	case CARGO_TYPE_ID.Loose:
		return 'WEIGHT';
	case CARGO_TYPE_ID.Other:
		return 'OTHER';
	case CARGO_TYPE_ID.Parcels:
		return 'CARTONS';
	case CARGO_TYPE_ID.CustomItem:
		return 'ITEM';
	case CARGO_TYPE_ID.Bundle:
		return 'BUNDLE';
	case CARGO_TYPE_ID.Skid:
		return 'SKID';
	default:
		return '';
	}
};
